export default "__VITE_ASSET__BSC4jEyL__"